import { pick } from 'lodash/fp';

import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler, makeGetByIds } from './utils';

const BASE_PATHNAME = 'events';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getByIds = makeGetByIds({ dataSource, url: `${BASE_PATHNAME}/getmany` });
  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();

  const getAppearance = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}/appearance`).json();
  const createAppearance = ({ id, values }) =>
    dataSource.post(`${BASE_PATHNAME}/appearance`, { json: { ...values, eventId: id } }).json();
  const updateAppearance = ({ id, values }) =>
    dataSource.put(`${BASE_PATHNAME}/appearance`, { json: { ...values, eventId: id } }).json();
  const upsertAppearance = ({ id, hasBeenCreated, values }) =>
    hasBeenCreated ? updateAppearance({ id, values }) : createAppearance({ id, values });

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['subCategoryNameUrlSlug', 'eventIdWa']),
    }),
    getWasList: getDefaultListHandler({
      url: `${BASE_PATHNAME}/was`,
      dataSource,
      transformFilter: pick(['subCategoryNameUrlSlug', 'eventIdWa']),
    }),
    getById,

    getByIds,

    getEmptyList: getDefaultEmptyList,

    getAppearance,
    createAppearance,
    updateAppearance,
    upsertAppearance,
  };
};
